import React, {FC, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {SelectWrapper} from '../../../../../../components/UI/Form/Input'
import {getClientById} from '../../../../services'
import {ClientModel} from '../../../../model'
import {useCentral} from '../../../../../../hooks/useCentral'
import {initValues} from '../../../../util/values/client'
import AditionalForm from '../../../../../../components/UI/Form/aditionalCamp/aditionalCampCentral'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
import {TITLE_FORM_CLIENT} from '../../../../util/Constants'
import {useEnterprise, useCompany} from '../../../../hooks'
const Index: FC = () => {
  const {setValue} = useFormContext()
  const {currentTabItem} = useCentral()
  const {companyList, getCompanyList} = useCompany()
  const {enterprise, getEnterpriseList} = useEnterprise()

  const getEnterpriseByIdValues = async () => {
    try {
      const response = await getClientById(currentTabItem.idToEdit)
      const data = response.data.data
      type ClientModelKeys = keyof ClientModel

      for (const fieldName in initValues) {
        if (initValues.hasOwnProperty(fieldName)) {
          if (data.hasOwnProperty(fieldName)) {
            if (data[fieldName as ClientModelKeys]) {
              if (fieldName === 'campoadicionalFec1') {
                let valueDep = data[fieldName as ClientModelKeys]
                if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                  const fechaLocal = new Date(valueDep)
                  const formattedDate = fechaLocal.toISOString().slice(0, 10)
                  setValue(fieldName, formattedDate)
                }
              } else if (fieldName === 'campoadicionalFec2') {
                let valueDep = data[fieldName as ClientModelKeys]
                if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                  const fechaLocal = new Date(valueDep)
                  const formattedDate = fechaLocal.toISOString().slice(0, 10)
                  setValue(fieldName, formattedDate)
                }
              } else {
                setValue(fieldName, data[fieldName as ClientModelKeys])
              }
            } else {
              setValue(fieldName, '')
            }
          }
        }
      }
    } catch (error) {
      console.error('Error al obtener la lista de países:', error)
    }
  }

  useEffect(() => {
    getEnterpriseList()
    getCompanyList()
  }, [])

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getEnterpriseByIdValues()
    }
  }, [currentTabItem.idToEdit])

  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <ContentForm isEdit={isDisabled} title={TITLE_FORM_CLIENT}>
      <div className='row'>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Compañía'
            name='companiaId'
            data={companyList}
            disabled={isDisabled}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Cliente'
            name='empresaId'
            data={enterprise}
            disabled={isDisabled}
            required
          />
        </div>
      </div>
      <hr className='divider' />
      <AditionalForm />
    </ContentForm>
  )
}

export default Index
